
import Vue from "vue";
import CupertinoAlertDialog from "@/components/ui/dialogs/CupertinoAlertDialog.vue";

interface Props {
  title: string;
  content: string;
  close?: string;
  isError?: boolean;
  width?: number;
  actionHandler?: () => void;
  outsideHandler?: () => void;
}

interface Data {}

interface Computed {}

interface Methods {
  onClickOutSide: () => void;
  onClickClose: () => void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { CupertinoAlertDialog },

  props: {
    title: String,
    content: String,
    close: {
      type: String,
      default() {
        return this.$t('common.close');
      },
      required: false,
    },
    isError: {
      type: Boolean,
      default: false,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
    actionHandler: {
      type: Function,
      required: false,
    },
    outsideHandler: {
      type: Function,
      required: false,
    },
  },

  methods: {
    onClickOutSide() {
      if (this.outsideHandler) this.outsideHandler();
      this.$close(false);
    },
    onClickClose() {
      if (this.actionHandler) this.actionHandler();
      this.$close(false);
    },
  },
});

export type SimpleDialogProps = Props;
